// import React from "react";
// import { useState, useEffect } from "react";

// // Chakra imports
// import {
//     Flex,
//     Icon,
//     Image,
//     Text,
//     useColorModeValue,
//     Link,
//     Button,
//     IconButton,
//     Tooltip,
//     useClipboard
// } from "@chakra-ui/react";
// // Custom components
// import Card from "components/card/Card.js";
// // Assets
// import { StarIcon, TriangleUpIcon } from "@chakra-ui/icons";
// import Amazon from 'assets/img/amazon.ico';
// import Flipkart from 'assets/img/flipkart.ico';
// import Snapdeal from 'assets/img/snapdeal.ico';
// import Meesho from 'assets/img/meesho.ico';
// import Glowroad from 'assets/img/glowroad.ico';
// import Shopsy from 'assets/img/shopsy.ico';

// import { MdCheckCircle, MdCancel, MdOutlineError, MdShoppingCart, MdContentCopy } from "react-icons/md";
// import { IoMdAlert } from "react-icons/io";





// export default function Item(props) {
//     const { product, handleUpdateSeller, removeFromUpdate, statusUpdate, setStatusUpdate, index, isAdmin } = props;
//     // Chakra Color Mode
//     const textColor = useColorModeValue("brands.900", "white");
//     const bgItem = useColorModeValue(
//         { bg: "white", boxShadow: "0px 40px 58px -20px rgba(112, 144, 176, 0.12)" },
//         { bg: "navy.700", boxShadow: "unset" }
//     );
//     const textColorDate = useColorModeValue("secondaryGray.600", "white");
//     const { hasCopied, onCopy } = useClipboard(product.prod_code);
//     const [toggleReport, setToggleReport] = useState(false);
//     const [toggleTest, setToggleTest] = useState(false);
//     const [toggleBlackList, setToggleBlackList] = useState(false);


//     const handleToggleReport = async (product) => {
//         setToggleReport(!toggleReport);
//         setToggleTest(false);
//         setToggleBlackList(false);
//         if (!toggleReport) {
//             await handleUpdateSeller(product, 'S');
//             setToggleReport(!toggleReport);
//         } else {
//             await removeFromUpdate(product, 'S');
//         }
//     }
//     const handleToggleTest = async (product) => {
//         setToggleReport(false);
//         setToggleTest(!toggleTest);
//         setToggleBlackList(false);
//         if (!toggleTest) {
//             await handleUpdateSeller(product, 'T');
//             setToggleTest(!toggleTest);
//         } else {
//             await removeFromUpdate(product, 'T');
//         }
//     }
    
//     useEffect(() => {
//         setToggleTest(false);
//         setToggleReport(false);
//         setStatusUpdate(false)
//     }, [statusUpdate]);

//     const getPlatformIcon = (platformId) => {
//         switch (platformId) {
//             case 1:
//                 return Amazon; // Use imported Amazon icon
//             case 2:
//                 return Flipkart; // Use imported Flipkart icon
//             case 3:
//                 return Snapdeal; // Use imported Snapdeal icon
//             case 4:
//                 return Meesho;
//             case 5:
//                 return Glowroad;
//             case 6:
//                 return Shopsy;
//         }
//     };
//     const renderStars = (rating) => {
//         rating = rating == -1 ? 0 : rating
//         const filledStars = Math.floor(rating);
//         const hasHalfStar = rating % 1 >= 0.5;
//         const totalStars = filledStars + (hasHalfStar ? 1 : 0);
//         const stars = [];

//         for (let i = 0; i < filledStars; i++) {
//             stars.push(<Icon as={StarIcon} color="gold" key={`star-${i}`} />);
//         }

//         if (hasHalfStar) {
//             stars.push(<Icon as={StarIcon} color="gold" key={`half-star`} />);
//         }

//         const emptyStars = 5 - totalStars;
//         for (let i = 0; i < emptyStars; i++) {
//             stars.push(<Icon as={StarIcon} color="gray.300" key={`empty-star-${i}`} />);
//         }

//         return stars;
//     };

//     const toolTipMessage = (status) => {
//         if (status === 10) {
//             return "Tested and verified seller";
//         }
//         if (status === 11) {
//             return "Official Seller"
//         }
//         if (status === 20) {
//             return "Test purchase and found Counterfeit products"
//         }
//         if (status === 21) {
//             return "Blacklisted Seller in our system"
//         }
//         if (!status) {
//             return "No information available"
//         }
//     }

//     return (
//         <Card
//             _hover={bgItem}
//             bg='transparent'
//             boxShadow='unset'
//             px='24px'
//             py='21px'
//             transition='0.2s linear'>
//             <Flex direction={{ base: "column" }} justify='center'>
//                 <Flex position='relative' align='center'>
//                     <Link href={product.image_link} isExternal me='15px'>
//                         <Image src={product.image_link} w='80px' me='16px' />
//                     </Link>
//                     <Flex
//                         direction='column'
//                         w={{ base: "70%", md: "100%" }}
//                         me={{ base: "4px", md: "32px", xl: "10px", "3xl": "32px" }}>

//                         <Text
//                             color={textColor}
//                             fontSize={{
//                                 base: "md",
//                             }}
//                             mb='5px'
//                             fontWeight='bold'
//                             me='14px'
//                         >
//                             {index + 1}.&nbsp;&nbsp;
//                             <Link href={product.prod_link} textDecoration='underline' isExternal>

//                                 {product.title}
//                             </Link>
//                         </Text>
//                         <Flex direction='row'>
//                             <Text
//                                 color='secondaryGray.600'
//                                 fontSize={{
//                                     base: "sm",
//                                 }}
//                                 fontWeight='400'
//                                 me='14px'>
//                                 {product.keyword}
//                                 <Image src={getPlatformIcon(product.platform_id)} width="15px" />

//                             </Text>
//                         </Flex>
//                         <Flex direction='row' hidden={product.store_name?.length<=0 || product.store_name === null}>
//                             <Text
//                                 color='secondaryGray.600'
//                                 fontSize={{
//                                     base: "sm",
//                                 }}
//                                 fontWeight='400'
//                                 me='14px'>
//                                 Store Name:
//                             </Text>
//                             <Text
//                                 color={textColor}
//                                 fontSize={{
//                                     base: "sm",
//                                 }}
//                                 mb='5px'
//                                 fontWeight='bold'
//                                 me='14px'
//                             >
//                                 {product.store_name}
//                             </Text>
//                         </Flex>
//                         <Flex direction='row'>
//                             <Text
//                                 color='secondaryGray.600'
//                                 fontSize={{
//                                     base: "sm",
//                                 }}
//                                 fontWeight='400'
//                                 me='14px'>
//                                 Product Code
//                             </Text>
//                             <Text
//                                 color={textColor}
//                                 fontSize={{
//                                     base: "sm",
//                                 }}
//                                 fontWeight='bold'
//                             >
//                                 {product.prod_code}
//                             </Text>
//                             <Tooltip label={hasCopied ? "Copied!" : "Copy to Clipboard"}>
//                                 <IconButton
//                                     aria-label="Copy to Clipboard"
//                                     icon={<MdContentCopy />}
//                                     onClick={onCopy}
//                                     variant="ghost"
//                                     colorScheme={hasCopied ? "green" : "gray"}
//                                     height='17px'
//                                 />
//                             </Tooltip>

//                         </Flex>
//                         <Flex direction='row' hidden={product.seller_name?.toLowerCase().startsWith("xxxx")}>
//                             <Text
//                                 color='secondaryGray.600'
//                                 fontSize={{
//                                     base: "sm",
//                                 }}
//                                 fontWeight='400'
//                                 me='14px'>
//                                 Seller Name:
//                             </Text>
//                             <Text
//                                 color={textColor}
//                                 fontSize={{
//                                     base: "sm",
//                                 }}
//                                 mb='5px'
//                                 fontWeight='bold'
//                                 me='14px'
//                             >
//                                 {product.seller_name}
//                             </Text>
//                             {product.global_status &&
//                                 <Tooltip label={toolTipMessage(product.global_status)}>
//                                     <IconButton
//                                         aria-label="Copy to Clipboard"
//                                         icon={(product.global_status === 20 || product.global_status === 21) ?
//                                             <IoMdAlert />
//                                             :
//                                             (product.global_status === 11 || product.global_status === 10) && <MdCheckCircle />}
//                                         variant="ghost"
//                                         colorScheme={(product.global_status === 21 || product.global_status === 20) ?
//                                             "red"
//                                             :
//                                             (product.global_status === 10 || product.global_status === 11) && "green"}
//                                         height='17px'
//                                     />
//                                 </Tooltip>
//                             }
//                         </Flex>
//                         <Flex direction='row' hidden={product.seller_name?.toLowerCase().startsWith("xxxx")}>
//                             <Text
//                                 color='secondaryGray.600'
//                                 fontSize={{
//                                     base: "sm",
//                                 }}
//                                 fontWeight='400'
//                                 me='14px'>
//                                 MRP :
//                             </Text>
//                             <Text
//                                 color={textColor}
//                                 fontSize={{
//                                     base: "sm",
//                                 }}
//                                 mb='5px'
//                                 fontWeight='bold'
//                                 me='14px'
//                             >
//                                 Rs. {product.mrp}
//                             </Text>
//                         </Flex>
//                         <Flex direction='row' hidden={product.seller_name?.toLowerCase().startsWith("xxxx")}>
//                             <Text
//                                 color='secondaryGray.600'
//                                 fontSize={{
//                                     base: "sm",
//                                 }}
//                                 fontWeight='400'
//                                 me='14px'>
//                                 Selling Price:
//                             </Text>
//                             <Text
//                                 color={textColor}
//                                 fontSize={{
//                                     base: "sm",
//                                 }}
//                                 fontWeight='semibold'
//                                 mb='5px'
//                                 me='14px'
//                             >
//                                 Rs. {product.selling_price}
//                             </Text>
//                         </Flex>
//                         <Flex direction='row' hidden={product.manufacturer?.length <=0 || product.manufacturer === null}>
//                             <Text
//                                 color='secondaryGray.600'
//                                 fontSize={{
//                                     base: "sm",
//                                 }}
//                                 fontWeight='400'
//                                 me='14px'>
//                                 Manufacturer:
//                             </Text>
//                             <Text
//                                 color={textColor}
//                                 fontSize={{
//                                     base: "sm",
//                                 }}
//                                 mb='5px'
//                                 fontWeight='bold'
//                                 me='14px'
//                             >
//                                 {product.manufacturer}
//                             </Text>
//                         </Flex>

//                         <Flex direction='row' hidden={product.seller_name?.toLowerCase().startsWith("xxxx")}>
//                             {renderStars(product.overall_rating)}
//                             <Text
//                                 color='secondaryGray.600'
//                                 fontSize={{
//                                     base: "sm",
//                                 }}
//                                 fontWeight='400'
//                                 me='14px'>
//                                 &nbsp;&nbsp;{product.no_of_rating}
//                             </Text>
//                         </Flex>
//                     </Flex>
//                     {isAdmin && (


//                         <Flex
//                             me={{ base: "4px", md: "32px", xl: "10px", "3xl": "32px" }}
//                             align='center' direction="column">

//                             <Tooltip label='Report seller'>
//                                 <Button colorScheme="gray" fontSize="20px" p='0px'
//                                     onClick={() => handleToggleReport(product)}>
//                                     <Icon color={toggleReport === true ? 'gold' : 'gray'} as={MdOutlineError} />
//                                 </Button>
//                             </Tooltip>
//                             <Tooltip label='Test Purchase'>
//                                 <Button colorScheme="gray" fontSize="20px" p='0px'
//                                     onClick={() => handleToggleTest(product)}>
//                                     <Icon color={toggleTest === true ? 'blue' : 'gray'} as={MdShoppingCart} />
//                                 </Button>
//                             </Tooltip>
//                             {/* <Tooltip label='Blacklist Seller'>
//                             <Button colorScheme="gray" fontSize="20px" p='0px' onClick={() => handleToggleBlackList(product.seller_id,product.keyword_id, product.platform_id, product.seller_name)}>
//                                 <Icon color={toggleBlackList === true ? 'red' : 'gray'} as={MdCancel} />
//                             </Button>
//                         </Tooltip> */}
//                         </Flex>
//                     )}

//                 </Flex>

//             </Flex>
//         </Card>
//     );
// }




import React, { useState, useEffect } from "react";
import {
    Flex, Icon, Image, Text, useColorModeValue, Link, Button, IconButton,
    Tooltip, useClipboard, Box, Checkbox, HStack, VStack, Badge
} from "@chakra-ui/react";
// Custom components
import Card from "components/card/Card.js";
// Assets
import { StarIcon } from "@chakra-ui/icons";
import { MdCheckCircle, MdShoppingCart, MdContentCopy, MdOutlineError, MdStore } from "react-icons/md";
import { IoMdAlert } from "react-icons/io";

import Amazon from 'assets/img/amazon.ico';
import Flipkart from 'assets/img/flipkart.ico';
import Snapdeal from 'assets/img/snapdeal.ico';
import Meesho from 'assets/img/meesho.ico';
import Glowroad from 'assets/img/glowroad.ico';
import Shopsy from 'assets/img/shopsy.ico';

// --- Internal Helper Components ---

// 1. Overlay Component (Adapted for Item functionality: Report & Test)
const StatusOverlay = ({ report, test }) => {
    if (!report && !test) return null;

    const config = report
        ? { icon: MdOutlineError, color: "gold", label: "REPORTED" }
        : { icon: MdShoppingCart, color: "blue.500", label: "TEST BUY" };

    return (
        <Box
            position="absolute"
            top="0" left="0" right="0" bottom="0"
            bg="blackAlpha.700"
            borderRadius="xl"
            zIndex="2"
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            transition="all 0.2s"
        >
            <Icon as={config.icon} color={config.color} w={10} h={10} mb={2} />
            <Text color="white" fontWeight="bold" fontSize="xs" letterSpacing="wider">
                {config.label}
            </Text>
        </Box>
    );
};

// 2. Action Buttons (Specific to Item: Report & Test)
const ActionButtons = ({ isAdmin, handlers, toggles, layout }) => {
    if (!isAdmin) return null;

    const { toggleReport, toggleTest } = toggles;
    const { onToggleReport, onToggleTest } = handlers;

    return (
        <HStack spacing={2} width={layout === 'grid' ? "100%" : "auto"} justify={layout === 'grid' ? "center" : "flex-end"}>
            <Tooltip label='Report seller'>
                <Button
                    size="md"
                    flex={layout === 'grid' ? 1 : 'unset'}
                    leftIcon={<Icon as={MdOutlineError} />}
                    colorScheme={toggleReport ? "red" : "red"}
                    variant={toggleReport ? "solid" : "outline"}
                    onClick={onToggleReport}
                >
                    {layout === 'grid' ? "Report" : ""}
                </Button>
            </Tooltip>

            <Tooltip label='Test Purchase'>
                <Button
                    size="md"
                    flex={layout === 'grid' ? 1 : 'unset'}
                    leftIcon={<Icon as={MdShoppingCart} />}
                    colorScheme={toggleTest ? "blue" : "gray"}
                    variant={toggleTest ? "solid" : "solid"}
                    onClick={onToggleTest}
                >
                    {layout === 'grid' ? "Test Buy" : ""}
                </Button>
            </Tooltip>
        </HStack>
    );
};

// --- GridView Design (Matches SuspiciousItem Grid) ---
const GridView = ({ product, index, isAdmin, handlers, toggles, common }) => {
    const { textColor, borderColor, getPlatformIcon, renderStars, onCopy, toolTipMessage } = common;
    const { toggleReport, toggleTest } = toggles;

    // Determine active border color based on state
    const activeColor = toggleReport ? "orange.400" : toggleTest ? "blue.400" : borderColor;
    const isSelected = toggleReport || toggleTest;

    return (
        <Card
            p='5px'
            bg={useColorModeValue("white", "navy.800")}
            transition='0.3s cubic-bezier(.25,.8,.25,1)'
            _hover={{ shadow: "lg", transform: "translateY(-4px)" }}
            border={isSelected ? "2px solid" : "1px solid"}
            borderColor={isSelected ? activeColor : borderColor}
            overflow='hidden' h="100%" display="flex" flexDirection="column" position="relative"
        >
            {/* Image Section */}
            <Box position='relative' bg='white' p='15px' h='200px' borderBottom="1px solid" borderColor={borderColor} borderRadius="xl" overflow="hidden">
                <StatusOverlay report={toggleReport} test={toggleTest} />

                <Link href={product.image_link} isExternal w='100%' h='100%' display="block">
                    <Image src={product.image_link} w='100%' h='100%' objectFit='contain' />
                </Link>

                {/* Platform Icon Box */}
                <Box position='absolute' top='10px' left='10px' bg="white" borderRadius="md" p="1" shadow="sm" border="1px solid" borderColor="gray.100">
                    <Image src={getPlatformIcon(product.platform_id)} w='18px' h='18px' />
                </Box>
                
                {/* Global Status Icon (Verified/Alert) */}
                {product.global_status && (
                     <Box position='absolute' top='10px' right='10px' >
                        <Tooltip label={toolTipMessage(product.global_status)}>
                            <Box bg="white" borderRadius="full" p={1} shadow="sm">
                                <Icon 
                                    as={(product.global_status === 20 || product.global_status === 21) ? IoMdAlert : MdCheckCircle} 
                                    color={(product.global_status === 20 || product.global_status === 21) ? "red.500" : "green.500"} 
                                    w={5} h={5}
                                />
                            </Box>
                        </Tooltip>
                     </Box>
                )}
            </Box>

            {/* Content Section */}
            <VStack px='15px' align='start' spacing='8px' flex='1' py={2}>
                <Link href={product.prod_link} isExternal w="100%">
                    <Text color={textColor} fontWeight='700' fontSize='sm' noOfLines={2} h="40px">
                        {index + 1}. {product.title}
                    </Text>
                </Link>

                <HStack w="100%" justify="space-between" align="center" hidden={product.seller_name?.toLowerCase().startsWith("xxxx")}>
                    <Text color={textColor} fontWeight='900' fontSize='xl'>₹{product.selling_price}</Text>
                    <HStack spacing='1px' >
                        {renderStars(product.overall_rating)}
                        <Text fontSize="xs" color="gray.500">({product.no_of_rating})</Text>
                    </HStack>
                </HStack>

                {/* Gray Info Box */}
                <VStack w='100%' align="start" spacing={1} bg={"gray.50"} p="2" borderRadius="md">
                    <HStack w="100%" justify="space-between">
                         <Text fontSize='13px' color="gray.500" noOfLines={1} hidden={product.seller_name?.toLowerCase().startsWith("xxxx")}>
                            Seller: <b>{product.seller_name}</b>
                        </Text>
                    </HStack>
                   
                   {product.store_name && (
                       <HStack fontSize='13px' color="gray.500">
                           <Icon as={MdStore} />
                           <Text noOfLines={1}>{product.store_name}</Text>
                       </HStack>
                   )}

                    <HStack w="100%" justify="space-between" pt={1} borderTop="1px dashed" borderColor="gray.200">
                        <Text fontSize='13px' color="gray.500">Code: <b>{product.prod_code}</b></Text>
                        <IconButton size='xs' icon={<MdContentCopy />} variant='ghost' h="20px" aria-label="Copy" onClick={onCopy} />
                    </HStack>
                </VStack>
            </VStack>

            {/* Action Footer */}
            {isAdmin && (
                <Box p={2} borderTop="1px solid" borderColor={borderColor}>
                    <ActionButtons isAdmin={isAdmin} handlers={handlers} toggles={toggles} layout="grid" />
                </Box>
            )}
        </Card>
    );
};

// --- ListView Design (Matches SuspiciousItem List) ---
const ListView = ({ product, index, isAdmin, handlers, toggles, common }) => {
    const { textColor, renderStars, getPlatformIcon, onCopy, toolTipMessage, hasCopied } = common;
    const { toggleReport, toggleTest } = toggles;
    
    const getBorderColor = () => {
        if (toggleReport) return "orange.400";
        if (toggleTest) return "blue.400";
        return "transparent";
    };

    const getBgColor = () => {
        if (toggleReport) return { bg: "orange.50", _dark: { bg: "rgba(237, 137, 54, 0.1)" } };
        if (toggleTest) return { bg: "blue.50", _dark: { bg: "rgba(66, 153, 225, 0.1)" } };
        return { bg: "white", _dark: { bg: "navy.800" } };
    };

    const bgStyles = getBgColor();
    return (
        <Card
            p="16px"
            mb="10px"
            position="relative"
            overflow="hidden"
            borderLeftWidth={toggleReport || toggleTest ? "5px" : "0px"}
            borderLeftColor={getBorderColor()}
            transition="all 0.2s"
            bg={bgStyles.bg}
            _dark={bgStyles._dark}
            boxShadow="sm"
            // _hover={{ boxShadow: "md" }}
        >
            <Flex align="center" gap={4}>
                {/* 1. Image Section */}
                <Box position="relative" w="100px" h="100px" flexShrink={0}>
                    <Link href={product.image_link} isExternal w='100%' h='100%' display="block">
                        <Image 
                            src={product.image_link} 
                            w="100%" 
                            h="100%" 
                            objectFit="contain" 
                            fallbackSrc="https://via.placeholder.com/100?text=No+Image"
                        />
                    </Link>
                    <Box 
                        position='absolute' bottom='0' left='0' 
                        bg="white" _dark={{ bg: "navy.900" }} 
                         p="1" shadow="sm"
                    >
                        <Image src={getPlatformIcon(product.platform_id)} w='16px' />
                    </Box>
                </Box>

                {/* 2. Details Section */}
                <Box flex="1">
                    {/* Title Row */}
                    <Flex align="center" mb={1} wrap="wrap">
                        <Text 
                            fontWeight="bold" 
                            fontSize="md" 
                            color="brands.900" 
                            _dark={{ color: "white" }} 
                            mr={2}
                        >
                            {index + 1}.&nbsp;
                            <Link href={product.prod_link} isExternal textDecoration="none" _hover={{ textDecoration: "underline" }}>
                                {product.title}
                            </Link>
                        </Text>
                        
                        {/* Status Badges */}
                        {toggleReport && <Badge colorScheme="orange" variant="solid" mr={2}>REPORTED</Badge>}
                        {toggleTest && <Badge colorScheme="blue" variant="solid" mr={2}>TEST BUY</Badge>}

                        {/* Global Status Icon */}
                        {product.global_status && (
                             <Tooltip label={toolTipMessage(product.global_status)}>
                                 <Box as="span" display="flex" alignItems="center">
                                     <Icon 
                                        as={(product.global_status === 20 || product.global_status === 21) ? IoMdAlert : MdCheckCircle} 
                                        color={(product.global_status === 20 || product.global_status === 21) ? "red.500" : "green.500"} 
                                     />
                                 </Box>
                             </Tooltip>
                        )}
                    </Flex>
                    
                    {/* Keyword & Rating Row */}
                    <HStack spacing={4} mb={2}>
                        <Text fontSize="sm" color="secondaryGray.600" _dark={{ color: "gray.400" }}>
                            {product.keyword}
                        </Text>
                        <HStack spacing="1px" hidden={product.seller_name?.toLowerCase().startsWith("xxxx")}>{renderStars(product.overall_rating)}</HStack>
                    </HStack>

                    {/* Price & Info Row */}
                    <Flex gap={6} align="center" fontSize="sm" wrap="wrap">
                        <Text hidden={product.seller_name?.toLowerCase().startsWith("xxxx")}  fontWeight="bold" color="brands.900" _dark={{ color: "white" }}>
                            ₹{product.selling_price}
                        </Text>
                        <Text hidden={product.seller_name?.toLowerCase().startsWith("xxxx")}  color="secondaryGray.600" textDecoration="line-through">
                            ₹{product.mrp}
                        </Text>
                        
                        <HStack>
                             <Text color="secondaryGray.500">Code: {product.prod_code}</Text>
                             <Tooltip label={hasCopied ? "Copied!" : "Copy Code"}>
                                <IconButton 
                                    size='xs' 
                                    icon={<MdContentCopy />} 
                                    onClick={onCopy} 
                                    variant='ghost' 
                                    aria-label="copy"
                                    colorScheme={hasCopied ? "green" : "gray"}
                                />
                             </Tooltip>
                        </HStack>
                        
                        <Text hidden={product.seller_name?.toLowerCase().startsWith("xxxx")} color="secondaryGray.600">
                            Seller: <Text as="span" fontWeight="semibold" color="brands.900" _dark={{ color: "white" }}>{product.seller_name}</Text>
                        </Text>
                    </Flex>
                </Box>

                {/* 3. Action Buttons */}
                {isAdmin && (
                    <Flex direction="column" gap={2} align="flex-end">
                         {/* <Tooltip label='Report seller'> */}
                            <IconButton
                                size="md"
                                icon={<Icon as={MdOutlineError} />}
                                colorScheme={toggleReport ? "red" : "red"}
                                variant={toggleReport ? "solid" : "outline"}
                                onClick={handlers.onToggleReport}

                            />
                        {/* </Tooltip> */}

                        {/* <Tooltip label='Test Purchase'> */}
                            <IconButton
                                size="md"
                                icon={<Icon as={MdShoppingCart} />}
                                colorScheme={toggleTest ? "blue" : "blue"}
                                variant={toggleTest ? "solid" : "ghost"}
                                onClick={handlers.onToggleTest}
                            />
                        {/* </Tooltip> */}
                    </Flex>
                )}
            </Flex>
        </Card>
    );
};

export default function Item(props) {
    const { product, handleUpdateSeller, removeFromUpdate, statusUpdate, setStatusUpdate, index, isAdmin, viewMode = "list" } = props;

    // Chakra Color Mode
    const textColor = useColorModeValue("brands.900", "white");
    const borderColor = useColorModeValue("gray.100", "whiteAlpha.100");
    const { hasCopied, onCopy } = useClipboard(product.prod_code);
    
    // State
    const [toggleReport, setToggleReport] = useState(false);
    const [toggleTest, setToggleTest] = useState(false);

    // Handlers (Keeping original logic)
    const handleToggleReport = async () => {
        setToggleReport(!toggleReport);
        setToggleTest(false);
        if (!toggleReport) {
            await handleUpdateSeller(product, 'S');
        } else {
            await removeFromUpdate(product, 'S');
        }
    };

    const handleToggleTest = async () => {
        setToggleReport(false);
        setToggleTest(!toggleTest);
        if (!toggleTest) {
            await handleUpdateSeller(product, 'T');
        } else {
            await removeFromUpdate(product, 'T');
        }
    };

    useEffect(() => {
        setToggleTest(false);
        setToggleReport(false);
        setStatusUpdate(false)
    }, [statusUpdate]);

    // Common Helpers
    const commonProps = {
        textColor,
        borderColor,
        onCopy,
        hasCopied,
        getPlatformIcon: (platformId) => {
            switch (platformId) {
                case 1: return Amazon;
                case 2: return Flipkart;
                case 3: return Snapdeal;
                case 4: return Meesho;
                case 5: return Glowroad;
                case 6: return Shopsy;
                default: return null;
            }
        },
        renderStars: (rating) => {
            rating = rating == -1 ? 0 : rating;
            const filledStars = Math.floor(rating);
            const hasHalfStar = rating % 1 >= 0.5;
            const stars = [];
            for (let i = 0; i < filledStars; i++) stars.push(<Icon as={StarIcon} color="gold" key={`s-${i}`} />);
            if (hasHalfStar) stars.push(<Icon as={StarIcon} color="gold" key={`hs`} />);
            const emptyStars = 5 - stars.length;
            for (let i = 0; i < emptyStars; i++) stars.push(<Icon as={StarIcon} color="gray.300" key={`e-${i}`} />);
            return stars;
        },
        toolTipMessage: (status) => {
            if (status === 10) return "Tested and verified seller";
            if (status === 11) return "Official Seller";
            if (status === 20) return "Counterfeit products";
            if (status === 21) return "Blacklisted Seller";
            return "No info";
        }
    };

    const handlers = {
        onToggleReport: handleToggleReport,
        onToggleTest: handleToggleTest
    };

    const toggles = {
        toggleReport,
        toggleTest
    };

    return viewMode === 'grid'
        ? <GridView {...props} handlers={handlers} toggles={toggles} common={commonProps} />
        : <ListView {...props} handlers={handlers} toggles={toggles} common={commonProps} />;
}